import React from 'react';
import PropTypes from 'prop-types';
import LoggedInIcon from './LoggedInIcon';

function LoggedInIconVM(props) {
  return <LoggedInIcon {...props} />;
}

LoggedInIconVM.propTypes = {
  userData: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    rewardsTotal: PropTypes.number,
  }),
};

LoggedInIconVM.defaultProps = {
  userData: {
    firstName: '',
    lastName: '',
    rewardsTotal: 0,
  },
};

export default LoggedInIconVM;
